
//export const meses = ["01","02","03","04","05","06","07","08","09","10","11","12"];

export const meses = {
  1: "janeiro",
  2: "fevereiro",
  3: "março",
  4: "abril",
  5: "maio",
  6: "junho",
  7: "julho",
  8: "agosto",
  9: "setembro",
  10: "outubro",
  11: "novembro",
  12: "dezembro"
};

export const ANO_MINIMO = 1994;

export const getAnos = () => {
    let anos = [];
    let d = new Date();
    let ano = d.getFullYear()
    while( ano >= ANO_MINIMO ){
        anos.push(ano);
        ano--;
    }
    return anos;
}

export const anos = getAnos();

export const getMesCompetencia = (data)=>{
    if( !data )
        return undefined;
    let arrayData = data.split("-");
    if(arrayData.length === 3 ){
        return arrayData[1];
    }else{
        return undefined;
    }
}

export const getAnoCompetencia = (data) => {
    if( !data )
        return undefined;
    let arrayData = data.split("-");
    if(arrayData.length === 3 ){
        return arrayData[0];
    }else{
        return undefined;
    }
}

//PRIMEIRO DIA DO MÊS
export const getDataCompetenciaInicio = (mes, ano) => {
    let primeiroDia =  new Date(ano,mes-1,1);
    return primeiroDia.toISOString().split('T')[0];

}

//ULTIMO DIA DO MÊS
export const getDataCompetenciaFinal = (mes, ano) => {
    let ultimoDia =  new Date(ano,mes,0);
    return ultimoDia.toISOString().split('T')[0];
}

export const getInicioCompetenciaAtual = () => {
    let hoje = new Date();
    let primeiroDia = new Date(hoje.getFullYear(),hoje.getMonth()-1,1);
    return primeiroDia.toISOString().split('T')[0];
}

export const getFimCompetenciaAtual = () => {
    let hoje = new Date();
    let ultimoDia =  new Date(hoje.getFullYear(),hoje.getMonth()+1,0);
    return ultimoDia.toISOString().split('T')[0];
}